import { useEffect } from "react";

import { IdentityContextProvider, AppStateLike } from "@examspark/api";

export const useSetIdentityContext = (state: AppStateLike) => {
  const userId = state.user?.id ?? null;
  const workspaceId = state.workspace?.id ?? null;
  const appId = state.app?.id ?? null;
  const useSystemAdmin = state.useSystemAdmin;
  const proxiedAppId = state.proxiedApp?.id ?? null;

  useEffect(() => {
    IdentityContextProvider.setContext({
      userId: userId ?? null,
      workspaceId: workspaceId ?? null,
      appId: appId ?? process.env.REACT_APP_EXAMSPARK_APP_ID ?? null,
      useSystemAdmin,
    });
  }, [appId, userId, workspaceId, useSystemAdmin, proxiedAppId]);
};
